import Analytics from '@/utils/analytics';
import React from 'react';
import WrenchIcon from '@assets/icons/wrench.svg';
import { createStyles } from '@/contexts/theme-context';
import { InboundListItem } from './types';
import { TouchableOpacity } from 'react-native';
import { useOrderInbounds } from '@/hooks/use-order-inbounds';

interface Props {
  inboundListItem: InboundListItem;
  navigateToCorrection: (item: InboundListItem) => void;
}

const ICON_SIZE = 16;
const ICON_BUTTON_SIZE = 32;

export const InboundDetailListItemCorrectionAction: React.FC<Props> = ({
  inboundListItem,
  navigateToCorrection,
}) => {
  const { isViewOnly } = useOrderInbounds();
  const [styles, theme] = useStyles();

  if (isViewOnly) {
    return null;
  }

  const onPress = () => {
    Analytics.track('order_inbound_detail.correction_item', {
      searchTerm: inboundListItem.title,
    });

    navigateToCorrection(inboundListItem);
  };

  return (
    <TouchableOpacity
      onPress={onPress}
      style={styles.icon}
      testID="order-inbound-correction-button"
    >
      <WrenchIcon
        height={ICON_SIZE}
        stroke={theme.sk.color.icon.primary}
        width={ICON_SIZE}
      />
    </TouchableOpacity>
  );
};

const useStyles = createStyles((theme) => ({
  icon: {
    alignItems: 'center',
    backgroundColor: theme.colors.background,
    borderRadius: ICON_BUTTON_SIZE,
    height: ICON_BUTTON_SIZE,
    justifyContent: 'center',
    width: ICON_BUTTON_SIZE,
  },
}));
